import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography, Paper, Box, Skeleton } from '@mui/material'
import { getViewInstance } from "../actions/viewinstance";
import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import Masonry from '@mui/lab/Masonry';
import HealthShelfContainer from "./partials/healthshelf/HealthShelfContainer";
import FilterComponent from "./partials/healthshelf/FilterComponent";
import { topicHydrate } from "../reducers/healthshelf_topic";
import { articleHydrate } from "../reducers/healthshelf_article";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

const HealthShelf = () => {
    const { user: currentUser } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [callVI, setCallVI] = useState(false)
    const { viewInstance, settings } = useSelector(state => state.viewinstance)

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(()=>{
        if(window !== undefined){
          window.scrollTo(0,0)
        }
      },[])
      
    const topicStatus = useSelector(state => state.topics.status)
    const articleStatus = useSelector(state => state.articles.status)

    const statusArray = [
        topicStatus === 'success' ? true : false
        , articleStatus === 'success' ? true : false
    ]



    useEffect(() => {
        console.log(location.pathname)
        if (!callVI && (!viewInstance || !viewInstance.HealthShelf) && currentUser && currentUser.AuthToken) {
            setCallVI(true);
            dispatch(getViewInstance('AFFC204B-8C80-47BC-AF88-BC75F0015092', currentUser.AuthToken))
        }
    }, [location.pathname])

    if (!callVI && (!viewInstance || !viewInstance.HealthShelf) && currentUser && currentUser.AuthToken) {
        setCallVI(true);
        dispatch(getViewInstance('AFFC204B-8C80-47BC-AF88-BC75F0015092', currentUser.AuthToken))
    }

    useEffect(() => {
        if (topicStatus === 'idle' && viewInstance && viewInstance.HealthShelf) {
            const topicStore = {}
            for (var i = 0; i < viewInstance.HealthShelf.Topics.length; i++) {
                let topic = viewInstance.HealthShelf.Topics[i]
                topicStore[topic.Id] = topic
            }
            dispatch(topicHydrate(topicStore))
        }
    }, [topicStatus, dispatch, viewInstance])

    useEffect(() => {
        if (articleStatus === 'idle' && viewInstance && viewInstance.HealthShelf) {
            const articleStore = {}
            for (var i = 0; i < viewInstance.HealthShelf.Articles.length; i++) {
                let article = viewInstance.HealthShelf.Articles[i]
                articleStore[article.Id] = article
            }

            dispatch(articleHydrate(articleStore))
        }

    }, [articleStatus, dispatch, viewInstance])




    return (
        <div>
            <Header />
            <Box style={{ marginTop: '150px', padding: '40px', }}>
                <Typography variant="h4" align="center">Health Shelf</Typography>
            </Box>


            <Box mt={1} p={2}>
                <Paper elevation={1}>
                    <FilterComponent />
                </Paper>
            </Box>

            {
                statusArray.indexOf(false) < 0 ?
                    (

                        <HealthShelfContainer />



                    ) : (

                        <Box p={2} mt={1}>
                            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>

                                <Grid item xs={12}>
                                    <Masonry
                                        columns={{ xs: 1, sm: 2, md: 3 }}
                                    >
                                        {
                                            [1, 2, 3, 4, 5, 6].map(x => {
                                                return (
                                                    <Paper elevation={2}>
                                                        <Skeleton variant="rectangular" animation="wave" sx={{ height: 0, paddingTop: "30%", width: "100%" }} />
                                                        <Box p={2}>
                                                            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                                                <Grid item xs={12}>
                                                                    <Skeleton variant="rectangular" animation="wave" sx={{ height: 0, paddingTop: "10%", width: "100%" }} />
                                                                </Grid>
                                                                <Grid item xs={10} >
                                                                    <Skeleton variant="rectangular" animation="wave" sx={{ height: 0, paddingTop: "45%", width: "100%" }} />
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </Paper>

                                                )
                                            })}
                                    </Masonry>
                                </Grid>
                            </Grid>
                        </Box>

                    )
            }
            <Footer />
        </div>
    );

};

export default HealthShelf;

/*  <Paper elevation={16} style={{marginTop: '100px', padding:'40px'}}>
          <h3>
              HOME
            </h3>
            <Button onClick={logoutUser}>Logout</Button>
            <TermsAndConditions props={TCS.TsAndCsPage}/>
          </Paper> */